module.exports = __webpack_public_path__ + "static/media/icon-catalog-products.39eeb0ed.svg";